var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230 301.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ee7d00;}.cls-2{fill:#343231;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.38,229.33H82.6A128.81,128.81,0,0,1,44,256.68s9.09,34,12,44.72c0,0,103.55-16.5,163-86.49L205.1,206.5A126.67,126.67,0,0,1,132.38,229.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 230,
    height: 230,
    rx: 44.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 67.46,
    cy: 109.32,
    rx: 9.33,
    ry: 14.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 160.8,
    cy: 109.32,
    rx: 9.33,
    ry: 14.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.25,171c8,0,13.5-7.57,10.13-14.19-6.86-13.45-23.17-22.91-42.21-22.91S79.82,143.38,73,156.83C69.59,163.45,75.09,171,83.09,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.69,87.39a5.91,5.91,0,0,0,3.87,2.38c16.52,3.92,49-1.09,51.68-20.1.43-3.12-1.33-10.71-6.23-7.1-5.17,3.8-8.7,9.08-14,12.8a29.42,29.42,0,0,1-18,5.45c-4.31-.14-9-1-13.19.19C25,82.08,23.31,85.11,24.69,87.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.31,87.39a5.91,5.91,0,0,1-3.87,2.38c-16.52,3.92-49-1.09-51.68-20.1-.43-3.12,1.33-10.71,6.23-7.1,5.17,3.8,8.7,9.08,14,12.8a29.42,29.42,0,0,0,18,5.45c4.31-.14,9-1,13.19.19C205,82.08,206.69,85.11,205.31,87.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.9395c0247a2e3ab94e7f1d6f840fd173.svg";
export { ForwardRef as ReactComponent };